module.exports = __webpack_public_path__ + "static/media/CTLA_9-178w.afaa4557.webp";